import { render } from "./RegisterForm.vue?vue&type=template&id=c54c1062"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/RegisterForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c54c1062"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c54c1062', __exports__)) {
    api.reload('c54c1062', __exports__)
  }
  
  module.hot.accept("./RegisterForm.vue?vue&type=template&id=c54c1062", () => {
    api.rerender('c54c1062', render)
  })

}


export default __exports__